import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';
var defaultDisabled = {
  regular: {
    cursor: 'not-allowed',
    opacity: 0.7
  },
  graphical: {
    cursor: 'not-allowed',
    opacity: 0.4
  }
};

var createGetDisabled = function createGetDisabled(options) {
  return function () {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'regular';
    return options[variant];
  };
};

export var createDisabled = function createDisabled(palette) {
  var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = typeof disabled === 'function' ? disabled(palette) : disabled,
      otherGetDisabled = _ref.getDisabled,
      otherOptions = _objectWithoutProperties(_ref, ["getDisabled"]);

  var mergedOptions = deepmerge(defaultDisabled, otherOptions, {
    clone: false
  });
  return _assign({
    getDisabled: otherGetDisabled || createGetDisabled(mergedOptions)
  }, mergedOptions);
};